import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import SearchIcon from '@mui/icons-material/Search';
import { Controller } from 'react-hook-form';
import * as yup from 'yup';
import { cnpj } from 'cpf-cnpj-validator';

yup.addMethod(yup.string, 'cnpj', function cnpjTest() {
  return this.test(
    'is-cnpj',
    () => 'CNPJ inválido',
    (value) => (value ? cnpj.isValid(value) : true)
  );
});

const formatCnpj = (value) => {
  let v = (value || '').replace(/\D/g, '');
  v = v.replace(/^(\d{2})(\d)/, '$1.$2');
  v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
  v = v.replace(/\.(\d{3})(\d)/, '.$1/$2');
  v = v.replace(/(\d{4})(\d)/, '$1-$2');
  v = v.replace(/(-\d{2})\d+?$/, '$1');
  return v;
};

const CNPJField = ({
  field,
  useFormRef,
  schema,
  label,
  onSearch,
  loading = false,
  ...props
}) => {
  const { control } = useFormRef;
  const fieldSchema = schema ? yup.reach(schema, field) : null;

  const endAdornment = onSearch ? (
    <InputAdornment position="end">
      {loading ? (
        <CircularProgress size={20} />
      ) : (
        <Tooltip title="Consultar dados do CNPJ na Receita Federal (BrasilAPI)">
          <span>
            <IconButton
              size="small"
              onClick={onSearch}
              disabled={props.disabled || loading}
              edge="end"
              aria-label="buscar dados do cnpj"
            >
              <SearchIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </InputAdornment>
  ) : null;

  return (
    <Controller
      name={field}
      control={control}
      render={({
        field: { onChange, onBlur, value, ref },
        fieldState: { error },
      }) => (
        <TextField
          fullWidth
          inputRef={ref}
          label={fieldSchema?.spec?.label ?? label ?? 'CNPJ'}
          required={!!fieldSchema?.exclusiveTests?.required}
          error={!!error}
          helperText={error?.message}
          value={value ?? ''}
          onChange={(e) => {
            const masked = formatCnpj(e.target.value);
            onChange(masked);
          }}
          onBlur={onBlur}
          InputProps={{
            endAdornment: endAdornment || props.InputProps?.endAdornment,
            ...props.InputProps,
          }}
          InputLabelProps={{
            shrink: Boolean(value) || undefined,
            ...props.InputLabelProps,
          }}
          {...props}
        />
      )}
    />
  );
};

export default CNPJField;
